import {Component, Input, OnInit} from '@angular/core';

import {MapToolsService} from '../../services/map-tools.service';
import {PermissionsService} from '../../../common/service/permissions.service';
import {AnnotationService} from '../../services/features/annotation.service';

@Component({
    selector: 'nlr-annotation',
    imports: [],
    templateUrl: './annotation.component.html',
    styleUrl: './annotation.component.scss'
})
export class AnnotationComponent implements OnInit {
    @Input()
    disabled: boolean;

    title: string = 'AnnotationComponent';

    permissions = ['EDIT_DESIGN', 'VIEW_DESIGN'];

    constructor(
        private annotationService: AnnotationService,
        private mapToolsService: MapToolsService,
        private permissionsService: PermissionsService
    ) {}

    ngOnInit() {
        this.mapToolsService.init(
            'ALIGN',
            () => this.annotationService.align(),
            null,
            () => this.disabled || !this.permissionsService.hasPermission(this.permissions)
        );

        this.mapToolsService.init(
            'FLIP',
            () => this.annotationService.flipAnnotations(),
            null,
            () => this.disabled || !this.permissionsService.hasPermission(this.permissions)
        );
    }

    getAlignTooltip() {
        return this.mapToolsService.getTooltipWithShortcut('ALIGN', 'Align annotation to a selected line feature');
    }

    getFlipTooltip() {
        return this.mapToolsService.getTooltipWithShortcut('FLIP', 'Flip annotation & polylines');
    }

    align() {
        this.mapToolsService.activate('ALIGN').subscribe();
    }

    flip() {
        this.mapToolsService.activate('FLIP').subscribe();
    }

    hasPermission() {
        return this.permissionsService.hasPermission(this.permissions);
    }

    isDisabled() {
        return this.disabled || !this.permissionsService.hasEditPermission(this.permissions);
    }
}
